exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tips {\n\t\tfont-size: 0.85em;\n\t\tcolor: red !important;\n}\n.idcard {\n\t\tfloat: left;\n\t\twidth: 50%;\n    text-align: center;\n}\n.avatar-uploader .el-upload {\n    border: 1px dashed #d9d9d9;\n    border-radius: 6px;\n    cursor: pointer;\n    position: relative;\n    overflow: hidden;\n}\n.avatar-uploader .el-upload:hover {\n    border-color: #409EFF;\n}\n.avatar-uploader-icon {\n    font-size: 28px;\n    color: #8c939d;\n    width: 148px;\n    height: 148px;\n    line-height: 148px;\n    text-align: center;\n}\n.avatar {\n    width: 148px;\n    height: 148px;\n    display: block;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5fa77d9c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/providerBankCard.vue
// module id = 204
// module chunks = 1